'use strict';

var KpiRibbonReferenceFilterFactory = function KpiRibbonReferenceFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['ROMAnalysisCabinFilterFactory', 'ROMAnalysisPOSFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function KpiRibbonReferenceFilter() {
    DemandFilter.call(this, ['rom-analysis-skinny-services-reference-mode'], ['kpi-ribbon-reference']);
    this.registerFilters(injectedFilters);
  }
  KpiRibbonReferenceFilter.constructor = KpiRibbonReferenceFilter;
  KpiRibbonReferenceFilter.prototype = Object.create(DemandFilter.prototype);
  KpiRibbonReferenceFilter.prototype.canFilter = function (sourceType, targetType) {
    return this.sourceType.indexOf(sourceType) !== -1 && this.targetType.indexOf(targetType) !== -1;
  };
  return KpiRibbonReferenceFilter;
};
KpiRibbonReferenceFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = KpiRibbonReferenceFilterFactory;